<app-legend #legend
  style="display: none">
  <app-legend-item color="green"
    [key]="BtpStatusCode.OK">Success
  </app-legend-item>
  <app-legend-item color="orange"
    [key]="BtpStatusCode.BadRequest">Wrong format
  </app-legend-item>
  <app-legend-item color="red"
    [key]="BtpStatusCode.InternalServerError">Internal error. Resending required
  </app-legend-item>
</app-legend>

<mat-card>
  <app-headline>
    <h1 app-headline-title
    color="primary">Requests</h1>
    <app-headline-actions class="headline-filters">

      <button mat-icon-button
        matTooltip="Download requests as json"
        (click)="download()">
        <mat-icon>download</mat-icon>
      </button>

      <mat-button-toggle-group [value]="view"
        appearance="legacy"
        (valueChange)="view = $event">
        <mat-button-toggle value="request">
          <mat-icon>north_east</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle value="response">
          <mat-icon>south_east</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>

    </app-headline-actions>
  </app-headline>

  <app-filter [columns]="['id', 'start_date_request', 'end_date_request', 'start_date_packet', 'end_date_packet', 'response_status', 'module_id', 'error_code', 'battery_id', 'parameters', 'packet_types', 'distinct_packets']"
    refreshControl="auto">

    <mat-form-field appearance="outline"
      filter-control>
      <mat-label>Request ID</mat-label>
      <input matInput
        formControlName="id">
    </mat-form-field>

    <mat-form-field appearance="outline"
      filter-control>
      <mat-label>Bin pack</mat-label>
      <mat-select formControlName="packet_types"
        multiple>
        @for (packetType of Dic.packet_types | keyvalue:comparePacket; track packetType) {
          <mat-option
            [value]="packetType.key">
            <small>[{{packetType.key | hex}}]</small> {{packetType.value}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline"
      filter-control>
      <mat-label>Response status</mat-label>
      <mat-select formControlName="response_status">
        <mat-option></mat-option>
        @for (status of Dic.response_data_statuses | keyvalue; track status) {
          <mat-option
            [value]="status.key">
            {{status.value}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline"
      filter-control>
      <mat-label>Module</mat-label>
      <mat-select formControlName="module_id">
        <mat-option></mat-option>
        @for (module of Dic.error_modules | keyvalue; track module) {
          <mat-option
            [value]="module.key">
            {{module.value}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline"
      filter-control>
      <mat-label>Error code</mat-label>
      <mat-select formControlName="error_code">
        <mat-option></mat-option>
        @for (error of errorCodes$ | async | keyvalue:compareCode; track error) {
          <mat-option
            [value]="error.key">
            <small>[{{error.key}}]</small> {{error.value}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline"
      filter-control>
      <mat-label>Battery</mat-label>
      <input matInput
        formControlName="battery_id">
    </mat-form-field>

    <mat-form-field appearance="outline"
      filter-control>
      <mat-label>Parameters</mat-label>
      <input matInput
        formControlName="parameters">
    </mat-form-field>

    <mat-form-field appearance="outline"
      filter-control>
      <mat-label>Start for request (UTC)</mat-label>

      <mtx-datetimepicker #startDateForRequest
        type="datetime"
        mode="portrait"
        startView="clock"
        [twelvehour]="false"
      [timeInput]="true"></mtx-datetimepicker>
      <input matInput
        [mtxDatetimepicker]="startDateForRequest"
        formControlName="start_date_request">
      <mtx-datetimepicker-toggle matSuffix
      [for]="startDateForRequest"></mtx-datetimepicker-toggle>
    </mat-form-field>

    <mat-form-field appearance="outline"
      filter-control>
      <mat-label>End for request (UTC)</mat-label>

      <mtx-datetimepicker #endDateForRequest
        type="datetime"
        mode="portrait"
        startView="clock"
        [twelvehour]="false"
      [timeInput]="true"></mtx-datetimepicker>
      <input matInput
        [mtxDatetimepicker]="endDateForRequest"
        formControlName="end_date_request">
      <mtx-datetimepicker-toggle matSuffix
      [for]="endDateForRequest"></mtx-datetimepicker-toggle>
    </mat-form-field>

    <mat-form-field appearance="outline"
      filter-control>
      <mat-label>Start for packet (UTC)</mat-label>

      <mtx-datetimepicker #startDateForPacket
        type="datetime"
        mode="portrait"
        startView="clock"
        [twelvehour]="false"
      [timeInput]="true"></mtx-datetimepicker>
      <input matInput
        [mtxDatetimepicker]="startDateForPacket"
        formControlName="start_date_packet">
      <mtx-datetimepicker-toggle matSuffix
      [for]="startDateForPacket"></mtx-datetimepicker-toggle>
    </mat-form-field>

    <mat-form-field appearance="outline"
      filter-control>
      <mat-label>End for packet (UTC)</mat-label>

      <mtx-datetimepicker #endDateForPacket
        type="datetime"
        mode="portrait"
        startView="clock"
        [twelvehour]="false"
      [timeInput]="true"></mtx-datetimepicker>
      <input matInput
        [mtxDatetimepicker]="endDateForPacket"
        formControlName="end_date_packet">
      <mtx-datetimepicker-toggle matSuffix
      [for]="endDateForPacket"></mtx-datetimepicker-toggle>
    </mat-form-field>

    <mat-form-field appearance="outline" filter-control>
      <mat-select [formControl]="sortPackets">
        <mat-option value="position_up">Position ↑</mat-option>
        <mat-option value="position_down">Position ↓</mat-option>
        <mat-option value="timestamp_up">Timestamp ↑</mat-option>
        <mat-option value="timestamp_down">Timestamp ↓</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-checkbox filter-control
      class="distinct-packets"
      formControlName="distinct_packets"
      color="primary"
      labelPosition="before">Distinct packets
    </mat-checkbox>
  </app-filter>

  <ngrx-busy>
    @for (row of requests$ | async; track row.id) {
      <div class="request-block">
        <div class="request-meta">
          <p class="request-summary">
            <strong><code class="protocol">{{row.protocol || '-'}}</code></strong>
            <span class="request-timing">
              <code class="elapsed">[{{row.elapsed}}ms]</code>
              <zoned-time [time]="row.created_at"
                [zone]="row.time_zone"
                format="MMM D, LTS"
                source="utc"></zoned-time>
            </span>
          </p>
          <p class="request-actions">
            <app-code>{{row.id}}</app-code>
            <button mat-icon-button
              aria-label="View request details"
              (click)="details(row)">
              <mat-icon>pageview</mat-icon>
            </button>
          </p>
        </div>
        <div class="request-packets"
          [legendRow]="legend"
          [legendRowValue]="row.response_status">
          <app-packets [slice]="20"
            [timeZone]="row.time_zone"
            [data]="view === 'request' ? row.request_packets : row.response_packets"></app-packets>
        </div>
      </div>
    }
    <mat-paginator [pageSizeOptions]="[20, 500]"></mat-paginator>
  </ngrx-busy>
</mat-card>
